import { useEffect } from 'react';
import '@n8n/chat/dist/style.css';
import './N8nChat.css';
import { createChat } from '@n8n/chat';
import { N8N_B2C_TOKEN, N8N_B2B_TOKEN } from '@env';
import { ChatOptions } from '@n8n/chat/dist/types';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import { N8nChatTarget } from './N8nChatButton.constants';

const N8nChat = observer(({ children }: { children: React.ReactNode }) => {
  const {
    i18n,
    user: { isRetailer },
  } = useStore();

  useEffect(() => {
    let configN8nChat: Partial<ChatOptions> = {
      target: N8nChatTarget,
      mode: 'window',
      metadata: {},
      showWelcomeScreen: false,
      defaultLanguage: i18n.language as any,
      initialMessages: [i18n.t('chat:initialMessage')],
      enableStreaming: true,
    };

    if (!isRetailer) {
      configN8nChat = {
        ...configN8nChat,
        webhookUrl: `https://sciccioni.app.n8n.cloud/webhook/${N8N_B2C_TOKEN}/chat`,
        i18n: {
          [i18n.language]: {
            title: i18n.t('chat:title'),
            subtitle: i18n.t('chat:subtitle'),
            footer: i18n.t('chat:footer'),
            inputPlaceholder: i18n.t('chat:inputPlaceholder'),
            getStarted: '',
            closeButtonTooltip: '',
          },
        },
      };
      document.documentElement.style.setProperty('--chat--color-primary', '#eb5d0b');
      document.documentElement.style.setProperty('--chat--color-primary-shade-50', 'rgba(235, 93, 11, 0.9)');
      document.documentElement.style.setProperty('--chat--color-primary-shade-100', 'rgba(235, 93, 11, 0.8)');
    } else {
      configN8nChat = {
        ...configN8nChat,
        webhookUrl: `https://sciccioni.app.n8n.cloud/webhook/${N8N_B2B_TOKEN}/chat`,
        i18n: {
          [i18n.language]: {
            title: i18n.t('chat:title') + ' PRO',
            subtitle: i18n.t('chat:subtitle'),
            footer: i18n.t('chat:footer'),
            inputPlaceholder: i18n.t('chat:inputPlaceholder'),
            getStarted: '',
            closeButtonTooltip: '',
          },
        },
      };
      document.documentElement.style.setProperty('--chat--color-primary', '#754afa');
      document.documentElement.style.setProperty('--chat--color-primary-shade-50', 'rgba(117, 74, 250, 0.9)');
      document.documentElement.style.setProperty('--chat--color-primary-shade-100', 'rgba(117, 74, 250, 0.8)');
    }

    createChat(configN8nChat);
  }, [isRetailer]);

  return children;
});

export default N8nChat;
